
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LogoScroller from '@/components/LogoScroller';
import PageHeader from '@/components/PageHeader';

const CodeOfConduct = () => {
  return (
    <div className="min-h-screen bg-ai-dark">
      <Helmet>
        <title>Code of Conduct - AI World Congress 2026 - November 25-26, London UK - AI Conference</title>
        <meta name="description" content="Code of Conduct for AI World Congress 2026. Our commitment to providing a harassment-free conference experience for everyone." />
        <link rel="canonical" href="https://aiconference.london/code-of-conduct" />
        <meta property="og:title" content="Code of Conduct - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
        <meta property="og:description" content="Our commitment to a harassment-free conference experience at AI World Congress 2026." />
        <meta property="og:url" content="https://aiconference.london/code-of-conduct" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Code of Conduct - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
      </Helmet>
      <Header />
      <PageHeader 
        title=""
        subtitle=""
        backgroundImage="/lovable-uploads/530fddbf-4fea-4198-860f-8165d2f8b445.png"
      />
      <div className="relative z-10 -mt-16">
        <div className="relative py-16 md:py-24 overflow-hidden bg-gradient-to-b from-purple-900/80 to-black">
          <div className="absolute inset-0 w-full h-full overflow-hidden z-0">
            <div className="absolute w-full h-[40%] bottom-0 bg-gradient-to-t from-black to-transparent"></div>
            <div className="absolute w-full h-[500px] bottom-0 left-0 right-0">
              <svg className="absolute bottom-0 w-full" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
                <path 
                  fill="#000000" 
                  fillOpacity="1" 
                  d="M0,128L48,138.7C96,149,192,171,288,176C384,181,480,171,576,144C672,117,768,75,864,80C960,85,1056,139,1152,160C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                  className="animate-pulse"
                  style={{ animationDuration: '15s' }}
                ></path>
              </svg>
            </div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold mb-8">
                <span className="text-white">Code of </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Conduct</span>
              </h1>
            </div>
          </div>
        </div>
      
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto prose prose-invert">
            <h3 className="text-xl font-semibold text-white mt-8 mb-4">1. Purpose</h3>
            <p className="text-gray-300 mb-4">
              AI Conference London is dedicated to providing a harassment-free conference experience for 
              everyone, regardless of gender, gender identity and expression, sexual orientation, disability, 
              physical appearance, body size, race, age, or religion.
            </p>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">2. Expected Behavior</h3>
            <p className="text-gray-300 mb-4">
              All participants, speakers, sponsors, and volunteers at our conference are expected to:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-4">
              <li>Be considerate, respectful, and collaborative</li>
              <li>Refrain from demeaning, discriminatory, or harassing behavior</li>
              <li>Alert conference organizers if you notice violations of this code of conduct</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">3. Unacceptable Behavior</h3>
            <p className="text-gray-300 mb-4">
              Unacceptable behaviors include intimidating, harassing, abusive, discriminatory, derogatory, 
              or demeaning conduct. Harassment includes offensive verbal comments, deliberate intimidation, 
              stalking, following, harassing photography or recording, sustained disruption of talks or other 
              events, inappropriate physical contact, and unwelcome sexual attention.
            </p>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">4. Consequences</h3>
            <p className="text-gray-300 mb-4">
              Participants asked to stop any harassing behavior are expected to comply immediately. If a 
              participant engages in harassing behavior, the conference organizers may take any action they 
              deem appropriate, including warning the offender or expulsion from the conference with no refund.
            </p>
          </div>
        </div>
      </div>
      <LogoScroller />
      <Footer />
    </div>
  );
};

export default CodeOfConduct;
